import { Box, Typography } from "@mui/material";
import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import Button from "../FormFields/Button";
import "./style/SignaturePad.css";
import { useTranslation } from "react-i18next";

export default function SignaturePad(props: any) {
  const { name, onSave } = props;

  const { t } = useTranslation();
  const signatureRef = useRef<SignatureCanvas>(null);
  const [signatureLengthError, setSignatureLengthError] = useState(false);

  const handleClear = () => {
    signatureRef.current?.clear();
    setSignatureLengthError(false);
  };

  const handleSave = () => {
    if (signatureRef.current) {
      const dataURL = signatureRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");

      if (dataURL.length > 5000) {
        setSignatureLengthError(false);
        onSave({
          target: {
            name: name,
            value: dataURL,
          },
        });
      } else {
        setSignatureLengthError(true);
      }
    }
  };

  return (
    <>
      {signatureLengthError && (
        <Typography color="red" variant="body2">
          {t(`FORM.ERRORS.signature_length`)}
        </Typography>
      )}
      <Box width={"100%"} zIndex={2000} className={"signature-pad-container"}>
        <SignatureCanvas
          ref={signatureRef}
          penColor="black"
          canvasProps={{
            className: "signature-canvas",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "20px",
            pointerEvents: "none",
          }}
        >
          <Button
            style={{ pointerEvents: "auto" }}
            color="default"
            label={t(`FORM.SUBMIT.clear_signature`)}
            onClick={handleClear}
          />
          <Button
            style={{ pointerEvents: "auto" }}
            color="error"
            label={t(`FORM.SUBMIT.sign`)}
            onClick={handleSave}
          />
        </div>
      </Box>
    </>
  );
}
